import React, {useCallback, useMemo, useState} from 'react';
import { Select, MenuItem, Box } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';

import {
  setDropdownSelectMode, setStudioTopView, setStudioBottomView
} from '../../../../store/modules/studio/actions';
import { StudioControlStyles } from '../../styles';
import {
  selectCameraRecording,
  selectCountdownCamera, selectIsCountdown, selectIsPlayPrompter,
  selectStudioTopView
} from '../../../../store/modules/studio/selectors';
import { studioViewPosition, StudioViewPositions } from '../../../../configs/studio';
import StudioToolTip from '../../actions/StudioToolTip';
import StyledInput from '../../actions/StyledInput';

const TopViewAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const currentTopView = useSelector(selectStudioTopView);
  const isRecording = useSelector(selectCameraRecording);
  const isCountdownCamera = useSelector(selectCountdownCamera);
  const isCountdown = useSelector(selectIsCountdown);
  const isPlayPrompter = useSelector(selectIsPlayPrompter);

  const disabled = useMemo(()=>{
    return Boolean(isRecording || isCountdown || isPlayPrompter || isCountdownCamera);
  },[isRecording, isCountdown, isPlayPrompter, isCountdownCamera]);

  const onChange = useCallback((event: React.ChangeEvent<{value: unknown}>) => {
    const eventValue = event.target.value as StudioViewPositions;
    if(eventValue !== currentTopView){
      dispatch(setStudioTopView(eventValue));
      dispatch(setStudioBottomView(currentTopView));
    }
  }, [dispatch, currentTopView]);

  const openHandler = useCallback(() => {
    setOpen(true);
    dispatch(setDropdownSelectMode(true));
  }, [dispatch, setOpen]);

  const closeHandler = useCallback(() => {
    setOpen(false);
    dispatch(setDropdownSelectMode(false));
  }, [dispatch, setOpen]);

  return (
    <StudioToolTip title="Select the content that will be shown in the top portion of the viewing area">
      <Box>
        <p className={classes.label}>Top View</p>
        <Select
          open={open}
          variant="outlined"
          className={clsx(classes.selection, classes.selectAutoWidth)}
          input={<StyledInput />}
          value={currentTopView}
          onChange={onChange}
          MenuProps={{ style: { zIndex: 2147483102 } }}
          onOpen={openHandler}
          onClose={closeHandler}
          disabled={disabled}
        >
          {studioViewPosition.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </StudioToolTip>
  );
};

export default TopViewAction;
